module.exports = __webpack_public_path__ + "static/media/fiscalia-logo.46fdc363.png";